import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import styles from "./styles.css";
import { FRANCHISE_DATA_POINTS } from "../../../constants/franchise-constants";
import Tick from "./images/tick.svg";
import Button from "../../shared/button";
import LoginSignupV2 from "../login-signup-v2";
import Skeleton from "./skeleton";
import { sendCustomGaEvents } from "../../../tracking";
import { registerInterestEvent } from "../../../constants/tracking-constants/franchise-ga";
import { useHistory } from "react-router";
import { NUMBER } from "../../../constants/app-constants";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import Banner from "./images/banner.jpeg";

const FranchiseHomeBanner = ({
    mainHeading,
    genericContent,
    isLoggedIn,
    secureToken,
    isSSR,
    checkForUserInterestConnect,
    fetchDataConnect,
    faqList
}) => {

    const [isFetching, setIsFetching] = useState(isLoggedIn);
    const [isUserLoginRequired, setIsUserLoginRequired] = useState(false);
    const [receivedInterest, setRecievedInterest] = useState(false);
    const history = useHistory();

    const { subHeading = "Open used cars franchise in your city now!" } = genericContent || {};

    useEffect(() => {
        if (isLoggedIn && secureToken) {
            setIsFetching(true);
            checkForUserInterestConnect(secureToken)
                .then(() => setRecievedInterest(true))
                .catch(() => setRecievedInterest(false))
                .finally(() => {
                    setIsFetching(false);
                });
        } else {
            setRecievedInterest(false);
            setIsFetching(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    useEffect(() => {
        if (!isSSR && (!mainHeading || faqList.length === NUMBER.ZERO)) {
            const payload = {
                expand: "seo_content,faq",
                cmsuri: "franchise"
            };
            fetchDataConnect(payload);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSSR]);

    const handleRedirection = async () => {
        await yieldToMain();
        history.push("/franchise-form/");
    };

    const onRegisterInterestClick = async (e) => {
        e.preventDefault();
        if (!isLoggedIn) {
            setIsUserLoginRequired(true);
        } else {
            handleRedirection();
        }
        await yieldToMain();
        sendCustomGaEvents(registerInterestEvent);
    };

    const onClose = () => {
        setIsUserLoginRequired(false);
    };

    const successCallback = () => {
        handleRedirection();
    };

    return (
        <React.Fragment>
            <Helmet>
                <link
                    rel="preload"
                    href={Banner}
                    as={"image"}
                    type={"image/jpeg"}
                    fetchpriority="high"
                />
            </Helmet>
            {isFetching ? <Skeleton /> :
                <div styleName={"styles.franchiseHomeBanner"}>
                    <img width="1440" height="672" src={Banner} alt="home banner" fetchpriority="high" styleName={"styles.banner"} />
                    <div styleName={"styles.bannerTextWrapper"}>
                        <div>
                            <h1>{!receivedInterest ? mainHeading : "Interest Received"}</h1>
                            <h2>{!receivedInterest ? subHeading : "Get ready to dwell into new opportunities"}</h2>
                        </div>
                        <ul styleName={"styles.dataPoints"}>
                            {FRANCHISE_DATA_POINTS.map(point => (
                                <li key={point}>
                                    <div styleName="point">
                                        <img src={Tick} height={24} width={24} alt="tick" />
                                        <p>{point}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                        {!receivedInterest && <Button text="Register Interest" onClick={onRegisterInterestClick} />}
                    </div>
                </div>
            }
            <LoginSignupV2
                onClose={onClose}
                onLoginSuccessCallback={successCallback}
                isVisible={isUserLoginRequired}
            />

        </React.Fragment>
    );
};

FranchiseHomeBanner.propTypes = {
    genericContent: PropTypes.object,
    mainHeading: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    secureToken: PropTypes.string,
    isSSR: PropTypes.bool,
    checkForUserInterestConnect: PropTypes.func,
    fetchDataConnect: PropTypes.func,
    faqList: PropTypes.array
};

export default FranchiseHomeBanner;
